// firebaseConfig.jsx
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyAd49BvdgEHPTXwICjaXipawnnvjT8Jd6Q",
  authDomain: "nexaart-3b358.firebaseapp.com",
  projectId: "nexaart-3b358",
  storageBucket: "nexaart-3b358.firebasestorage.app",
  messagingSenderId: "559868416459",
  appId: "1:559868416459:web:533509f4f484f0bc2aa64e"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const db = getDatabase(app);
const auth = getAuth(app);
const storage = getStorage(app); // Initialize Firebase storage

export { db, auth, storage };
